import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Header from "../Header/Header";
import { WithHeaderContainer } from "./WithHeader.style";
var WithHeader = function(param) {
    var story = param.story, children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            children,
            story.header && /*#__PURE__*/ _jsx(WithHeaderContainer, {
                children: /*#__PURE__*/ _jsx(Header, {
                    heading: story.header.heading,
                    subheading: story.header.subheading
                })
            })
        ]
    });
};
export default WithHeader;
